import React from 'react';
import { FontIcon } from 'material-ui';
const logoGlobeSrc = require('../../../../www/images/tourconnect-logo-globe.svg');

const FilterHeader = ({ iconClassName, iconColor, text }) => {
  return (
    <div style={{ display: 'flex', width: '100%', alignItems: 'center', margin: '0 0 2% 11%' }}>
      {text === 'Recommendations' && <img src={logoGlobeSrc} width="42"/>}
      {iconClassName && <FontIcon color={iconColor} className={iconClassName} style={{ fontSize: '28px' }}/>}
      <div style={{ display: 'inline-block', fontSize: '20px', fontWeight: 600, marginLeft: '2%' }}>{text}</div>
    </div>
  );
};

export default FilterHeader;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/filterHeader.jsx